var map = {
	"./apps-1.svg": 7759,
	"./apps-10.svg": 1892,
	"./apps-11.svg": 2815,
	"./apps-12.svg": 5357,
	"./apps-13.svg": 2186,
	"./apps-14.svg": 4963,
	"./apps-15.svg": 701,
	"./apps-16.svg": 3416,
	"./apps-17.svg": 4261,
	"./apps-18.svg": 7085,
	"./apps-19.svg": 8037,
	"./apps-2.svg": 6539,
	"./apps-20.svg": 4032,
	"./apps-21.svg": 6187,
	"./apps-3.svg": 6287,
	"./apps-4.svg": 2882,
	"./apps-5.svg": 3301,
	"./apps-6.svg": 5200,
	"./apps-7.svg": 4178,
	"./apps-8.svg": 659,
	"./apps-9.svg": 9385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1030;